import {downloadInvoice} from '../invoice-download.js'
import {request} from '@/http/http.js'


// 登录  /api/member/login
export function login(query) {
  return request({
    url: '/api/member/login',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: query
  })
}

export function logout() {
  return request({ url: '/api/member/logout', method: 'post', data: {} })
}

// 找回密码 /api/member/reset_password
export function reqResetPassword(query) {
  return request({
    url: '/api/member/req_reset_password',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

// 修改密码 /api/member/reset_password
export function resetPassword(query) {
  return request({
    url: '/api/member/reset_password',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

// 检查邮箱是否可注册 /api/member/check_email
export function checkEmail(query) {
  return request({
    url: '/api/member/check_email',
    method: 'get',
    params: query
  })
}

// 获取邮箱验证码 /api/member/email_code
export function getEmailCode(query) {
  return request({
    url: '/api/member/email_code',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

// 检查邮箱验证码 /api/member/check_code
export function checkCode(query) {
  return request({
    url: '/api/member/check_code',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

// 注册  /api/member/sign_up
export function signUp(query) {
  return request({
    url: '/api/member/sign_up',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

// 用户信息 /api/member/info
export function getUser(query) {
  return request({
    url: '/api/member/info',
    method: 'get',
    params: query
  })
}

// 获取钱包信息 /api/member/wallet
export function getWalletInfo(query) {
  return request({
    url: '/api/member/wallet',
    method: 'get',
    data: query,
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

 // stripe支付 /api/payment/recharge
 export function stripeRecharge(query) {
  return request({
    url: '/api/payment/recharge',
    method: 'post',
    data: query,
    headers: {
     'Content-Type': 'application/json',
   }
  })
}

// 检查订单支付结果 /api/member/recharge-status
export function getRechargeStatus(query) {
 return request({
   url: '/api/member/recharge_status',
   method: 'get',
   params: query
 })
}

// 订单列表 /api/member/recharge_orders
export function getRechargeOrderList(query) {
  return request({
    url: '/api/member/recharge_orders',
    method: 'get',
    params: query
  })
}

// export order invoce
export function exportRechargeInvoice(query) {
  return downloadInvoice('/api/invoice/export_recharge_invoice', query)
}

// 支付流水
export function getBalancePayLogList(query) {
  return request({
    url: '/api/member/balance_log',
    method: 'get',
    params: query
  })
}

// 获取测试IP剩余抽取次数
export function getUserAuthorities(query) {
  return request({
    url: '/api/member/authorities',
    method: 'get',
    params: query
  })
}

// 获取测试IP剩余抽取次数
export function getProxyUser(query) {
  return request({
    url: '/api/member/proxy_user',
    method: 'get',
    params: query
  })
}

// 获取流量使用趋势
export function getTrafficUsages(query) {
  return request({
    url: '/api/member/traffic_usage',
    method: 'post',
    params: query
  })
}

// 获取用户的IP标签列表
export function getUserTags(query) {
  return request({
    url: '/api/member/tags',
    method: 'get',
    params: query
  })
}
